// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__o269d","title":"AfterBackImages_title__2LzHh","images":"AfterBackImages_images__Be4sc"};